import { Link } from "react-router-dom";
import { comments } from "@/mocks/comments";

export default function CommentList() {
  return (
    <section
      aria-label="网友热评"
      className="mt-10 rounded-lg border border-background-200 overflow-hidden"
    >
      <div className="flex items-center justify-between px-4 md:px-6 py-4 bg-background-100 border-b border-background-200">
        <h2 className="text-base font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-7 h-7 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
            <i className="ri-chat-smile-2-line" aria-hidden="true"></i>
          </span>
          网友热评
        </h2>
        <span className="text-xs text-foreground-400">精选讨论</span>
      </div>

      <ul className="divide-y divide-background-100">
        {comments.map((comment) => (
          <li key={comment.id} className="flex gap-3 px-4 md:px-6 py-4">
            <img
              src={comment.avatar}
              alt={`${comment.name}的头像`}
              title={`${comment.name} - 瓜友会网热评`}
              className="w-9 h-9 md:w-10 md:h-10 rounded-full shrink-0 object-cover object-top border border-background-200"
            />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <span className="text-sm font-medium text-foreground-900">
                  {comment.name}
                </span>
                <span className="text-xs text-foreground-400">{comment.time}</span>
              </div>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="mt-2 flex items-center gap-4 text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1 text-primary-500">
                  <i className="ri-thumb-up-line" aria-hidden="true"></i>
                  {comment.likes}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-chat-3-line" aria-hidden="true"></i>
                  回复
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>

      <div className="px-4 md:px-6 py-5 bg-background-100 border-t border-background-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-sm text-foreground-500">
          想补充线索或发表看法？欢迎投递给我们整理进时间线。
        </p>
        <Link
          to="/about#submit"
          className="shrink-0 inline-flex items-center justify-center gap-1 h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-edit-2-line" aria-hidden="true"></i>
          参与讨论
        </Link>
      </div>
    </section>
  );
}